module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10215.83124a33.jpg";